import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function About() {
  const { ref: sectionRef, isVisible } = useScrollAnimation({ threshold: 0.2 });

  const credentials = [
    { icon: 'ri-translate-2', text: '多益 TOEIC 795 分（2025.12）' },
    { icon: 'ri-bank-line', text: '金融市場常識與職業道德　合格' },
    { icon: 'ri-shield-check-line', text: '防制洗錢及打擊資恐職前研習班　合格' },
  ];

  return (
    <section id="about" className="py-16 md:py-24 px-4 md:px-8 bg-white" ref={sectionRef}>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20 items-center">

          {/* Left — Photo */}
          <div className={`relative transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'}`}>
            <div className="rounded-3xl overflow-hidden h-[560px]">
              <img
                src="/photo.JPG"
                alt="Frances Shen"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-gradient-to-br from-orange-400 to-rose-400 rounded-full opacity-20 blur-2xl animate-pulse-soft"></div>
            <div className="absolute -bottom-6 -left-6 w-40 h-40 bg-gradient-to-br from-amber-400 to-orange-400 rounded-full opacity-20 blur-2xl animate-pulse-soft" style={{ animationDelay: '2s' }}></div>
          </div>

          {/* Right Content */}
          <div>
            <div
              className={`inline-block px-4 py-2 bg-orange-100 rounded-full mb-6 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: '100ms' }}
            >
              <span className="text-sm font-semibold text-orange-700">關於我</span>
            </div>

            <h2
              className={`text-3xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ fontFamily: 'Playfair Display, serif', transitionDelay: '200ms' }}
            >
              認識<br />Frances Shen
            </h2>

            <p
              className={`text-base text-gray-600 leading-relaxed mb-4 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: '300ms' }}
            >
              我在律師事務所歷任行政秘書與法務專員，累積超過 2 年半的實務經驗，負責訴訟案件流程管理、法律文書草擬與審閱、跨機關協調及法律研究，養成了嚴謹的邏輯思維與結構化分析習慣。
            </p>
            <p
              className={`text-base text-gray-600 leading-relaxed mb-8 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: '400ms' }}
            >
              目前正積極轉型為數據分析師／數據工程師，透過自主學習 Python、SQL 與資料視覺化工具，並持續以個人專案累積實作經驗，期望將法律領域的結構化思維融入資料工作。
            </p>

            {/* Credentials */}
            <div className="space-y-4 mb-8">
              {credentials.map((credential, index) => (
                <div
                  key={index}
                  className={`flex items-center gap-3 transition-all duration-700 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'}`}
                  style={{ transitionDelay: `${500 + index * 100}ms` }}
                >
                  <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className={`${credential.icon} text-orange-600 text-lg`}></i>
                  </div>
                  <span className="text-sm font-medium text-gray-700">{credential.text}</span>
                </div>
              ))}
            </div>

            <div
              className={`flex gap-4 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: '800ms' }}
            >
              <Link
                to="/experience"
                className="px-8 py-3 rounded-full font-semibold text-base bg-gray-900 text-white hover:bg-gray-800 hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                查看我的經歷
              </Link>
              <Link
                to="/skills"
                className="px-8 py-3 rounded-full font-semibold text-base border-2 border-orange-500 text-orange-600 hover:bg-orange-50 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                我的技能
              </Link>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
